import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  canonicalizePositionWorkspaceRoute,
  LEGACY_WORKSPACE_CHART_LAB_PATH,
  POSITION_WORKSPACE_FALLBACK_PATH,
} from '../lib/positionWorkspaceRoute.js'

const STORAGE_KEY = 'erevis_last_page'
export const POSITION_WORKSPACE_STORAGE_KEY = 'erevis_last_position_workspace_page'
const LEGACY_WORKSPACE_CHART_LAB_STORAGE_KEY = 'erevis_last_workspace_chart_lab_page'

function pageFromLocation(location) {
  if (!location?.pathname) return null
  return `${location.pathname}${location.search || ''}`
}

function readStorage(key) {
  try {
    return localStorage.getItem(key) || null
  } catch {
    return null
  }
}

function writeStorage(key, value) {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Ignore storage failures; navigation should still work.
  }
}

function isPositionWorkspacePage(page) {
  if (!page) return false
  let pathname
  try {
    pathname = new URL(page, 'https://erevis.local').pathname
  } catch {
    return false
  }
  return pathname === POSITION_WORKSPACE_FALLBACK_PATH
}

export function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    if (location.pathname && !location.pathname.startsWith('/auth')) {
      const page = pageFromLocation(location)
      writeStorage(STORAGE_KEY, page)
      if (isPositionWorkspacePage(page)) {
        writeStorage(POSITION_WORKSPACE_STORAGE_KEY, POSITION_WORKSPACE_FALLBACK_PATH)
      }
    }
  }, [location.pathname, location.search])
}

export function getLastVisitedPage() {
  return readStorage(STORAGE_KEY)
}

export function getLastPositionWorkspacePage() {
  const legacySaved = readStorage(LEGACY_WORKSPACE_CHART_LAB_STORAGE_KEY)
  if (legacySaved?.startsWith(LEGACY_WORKSPACE_CHART_LAB_PATH)) {
    const canonical = canonicalizePositionWorkspaceRoute(legacySaved)
    if (canonical.pathname === POSITION_WORKSPACE_FALLBACK_PATH) {
      return POSITION_WORKSPACE_FALLBACK_PATH
    }
  }

  return POSITION_WORKSPACE_FALLBACK_PATH
}

// Transitional aliases for older call sites and saved-state tests. Both now
// resolve to the canonical Position Workspace rather than the demo route.
export const WORKSPACE_CHART_LAB_PATH = POSITION_WORKSPACE_FALLBACK_PATH
export const WORKSPACE_CHART_LAB_STORAGE_KEY = POSITION_WORKSPACE_STORAGE_KEY
export const getLastWorkspaceChartLabPage = getLastPositionWorkspacePage
export { POSITION_WORKSPACE_FALLBACK_PATH }
